<template>
  <div 
    v-if="showWhenEnabled"
    class="printer-connection-status"
  >
    <div 
      v-if="labelText"
      class="printer-connection-status__container"
      :class="{ 'clickable': !isConnected }"
      @click="handleContainerClick"
    >
      <span class="printer-connection-status__label mr-n3">
        {{ labelPrefix }}
        <span 
          class="printer-connection-status__status"
          :class="{
            connected: isConnected,
            disconnected: !isConnected,
          }"
        >{{ statusText }}</span>
      </span>
      <md-button
        class="websocket-icon md-icon-button"
        :md-tooltip="tooltipText"
        :class="{
          connected: isConnected,
          disconnected: !isConnected,
        }"
        @click="handleIconClick"
      >
        <md-icon
          v-if="isConnected"
          :md-src="connectedIcon"
        />
        <md-icon
          v-else
          :md-src="disconnectedIcon"
        />
      </md-button>
      <md-tooltip>
        {{ tooltipStatusText }}
      </md-tooltip>
    </div>

    <md-button
      v-else
      class="websocket-icon md-icon-button"
      :md-tooltip="tooltipText"
      :class="{
        connected: isConnected,
        disconnected: !isConnected,
      }"
      @click="handleIconClick"
    >
      <md-icon
        v-if="isConnected"
        :md-src="connectedIcon"
      />
      <md-icon
        v-else
        :md-src="disconnectedIcon"
      />
      <md-tooltip>{{ tooltipStatusText }}</md-tooltip>
    </md-button>
  </div>
</template>

<script>
import { usePrinter } from './composables/usePrinter'
import { mapGetters } from 'vuex'

export default {
  name: 'PrinterConnectionStatus',
  props: {
    connectedIcon: {
      type: String,
      default: '/static/images/icon-printer-connected.svg'
    },
    disconnectedIcon: {
      type: String,
      default: '/static/images/icon-printer-desconnected.svg'
    },
    tooltipText: {
      type: String,
      default: 'Status da conexão'
    },
    connectedText: {
      type: String,
      default: 'Conectado'
    },
    disconnectedText: {
      type: String,
      default: 'Desconectado'
    },
    connectingText: {
      type: String,
      default: 'Conectando...'
    },
    labelText: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['toggle', 'webSocketStatus']),
    printerPluginEnabled() {
      return this.toggle?.printerPlugin || false
    },
    connectionState() {
      return this.webSocketStatus?.connectionState || 'disconnected'
    },
    isConnected() {
      return this.connectionState === 'connected'
    },
    showWhenEnabled() {
      return this.printerPluginEnabled
    },
    statusText() {
      const { getStatusText } = usePrinter()
      return getStatusText(this.connectionState, {
        connected: this.connectedText,
        connecting: this.connectingText,
        disconnected: this.disconnectedText
      })
    },
    tooltipStatusText() {
      const { getStatusText } = usePrinter()
      return getStatusText(this.connectionState, {
        connected: 'Plugin de impressão Conectado',
        connecting: 'Plugin de impressão Conectando...',
        disconnected: 'Plugin de impressão Desconectado'
      })
    },
    labelPrefix() {
      if (!this.labelText) return ''
      const parts = this.labelText.split(':')
      return parts.length > 1 ? parts[0] + ': ' : ''
    }
  },
  methods: {
    handleContainerClick() {
      if (!this.isConnected) {
        this.$emit('download-plugin-requested')
      }
    },
    handleIconClick() {
      if (!this.isConnected) {
        this.$emit('download-plugin-requested')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.printer-connection-status {
  display: inline-block;

  &__container {
    display: flex;
    align-items: center;
    gap: 5px;
    
    &.clickable {
      cursor: pointer;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #7a7a7a;
    white-space: nowrap;
  }

  &__status {
    transition: color 0.3s ease;
    
    &.connected {
      color: #4caf50;
    }
    
    &.disconnected {
      color: #f44336;
    }
  }
}

.websocket-icon {
  display: flex;
  justify-content: center;
  align-content: center;
  transition: color 0.3s ease;

  .md-icon {
    padding: 4px;
    width: 45px;
    height: 45px;
    top: -6px;
    right: 0;
    bottom: 0;
    left: -5px;
    transition: filter 0.3s ease;
  }

  &.connected {
    color: #4caf50;
    
    .md-icon {
      filter: brightness(1.1);
    }
  }

  &.disconnected {
    color: #f44336;
    cursor: pointer;
    
    .md-icon {
      filter: brightness(0.9);
    }
    
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
